import React, { forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from './cn';

const BASE =
  'block w-full appearance-none rounded-lg text-sm transition-all duration-200 bg-surface-sunken text-heading border shadow-xs focus:outline-none disabled:cursor-not-allowed disabled:opacity-70';

const STATE = {
  default: 'border-line-strong focus:border-brand focus:ring-1 focus:ring-brand',
  error: 'border-red-500 focus:border-red-500 focus:ring-1 focus:ring-red-500',
  success: 'border-emerald-500 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500',
};

/** Select native được style theo design system + chevron. */
export const Select = forwardRef(function Select({ className, state = 'default', children, ...props }, ref) {
  return (
    <div className="relative">
      <select
        ref={ref}
        className={cn(BASE, STATE[state] || STATE.default, 'pl-3 pr-9 py-2.5', className)}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted"
        aria-hidden="true"
      />
    </div>
  );
});

export default Select;
